import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { PermissionsService } from 'src/app/services/permissions.service';
import { RoleGuard } from './role.abstract.guard';

@Injectable({ providedIn: 'root' })
export class SupportGuard extends RoleGuard {
  role: string[] = ['support'];
}
